const getScrollDimensions = () => {
  const div = document.createElement("div");
  div.style.width = 100;
  div.style.height = 100;
  div.style.position = "absolute";
  div.style.top = -9999;
  div.style.overflow = "scroll";

  document.body.appendChild(div);
  const horizontalScrollHeight = div.offsetHeight - div.clientHeight;
  const verticalScrollWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);

  return {
    horizontal: horizontalScrollHeight,
    vertical: verticalScrollWidth,
  };
};

export default getScrollDimensions;
